import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ONE_HUNDRED_PERCENT_NUMERIC_FORMAT } from 'common/constants';
import { ISku } from 'v3/services/interfaces/response';
import { productsInitialState } from './state';
import {
  IGroupProduct,
  IGroupProducts,
  IProduct,
  IProducts,
  ISkusProducts,
  IUpdateProduct,
  IUpdateProductLmi,
  IUpdateProductMaxPercentage,
} from './types';

export const productsSlice = createSlice({
  name: 'products',
  initialState: productsInitialState,
  reducers: {
    setProducts: (state, action: PayloadAction<IProducts>) => {
      state.products = action.payload;
      return state;
    },
    setGroupProducts: (state, action: PayloadAction<IGroupProducts>) => {
      state.groupProducts = action.payload;
      return state;
    },
    setProductsSkus: (state, action: PayloadAction<ISkusProducts>) => {
      state.sku = action.payload;
      return state;
    },
    setProductSelected: (state, action: PayloadAction<IProduct>) => {
      state.productSelected = action.payload;
      return state;
    },
    setGroupProductSelected: (state, action: PayloadAction<IGroupProduct>) => {
      state.groupProductSelected = action.payload;
      return state;
    },
    setSkuSelected: (state, action: PayloadAction<ISku>) => {
      state.skuSelected = action.payload;
      return state;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.productsFilter.page = action.payload;
      return state;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.productsFilter.limit = action.payload;
      return state;
    },
    setModelNameFilter: (state, action: PayloadAction<string>) => {
      state.productsFilter.model = action.payload;
      return state;
    },
    setProductAvailability: (state, action: PayloadAction<boolean | null>) => {
      state.productsFilter.available = action.payload;
      return state;
    },
    setProductValues: (state, action: PayloadAction<IUpdateProduct>) => {
      state.products.items.forEach((item) => {
        if (item.id === action.payload.id) {
          item.storePrice = action.payload.storePrice;
          item.available = action.payload.available;
        }
      });
      return state;
    },

    groupProductsHotUpdate: (state, action: PayloadAction<IGroupProduct>) => {
      state.groupProducts.items.forEach((item) => {
        if (item.sku.id === action.payload.sku.id) {
          item.price = action.payload.price;
          item.availability = action.payload.availability;
        }
      });
      return state;
    },
    setProductLmi: (state, action: PayloadAction<IUpdateProductLmi>) => {
      state.sku.items.forEach((item) => {
        if (item.id === action.payload.id) {
          item.lmi = action.payload.lmi;
          item.storage = action.payload.storage;
        }
      });
      return state;
    },

    setProductMaxPercentage: (state, action: PayloadAction<IUpdateProductMaxPercentage>) => {
      state.sku.items.forEach((item) => {
        if (item.id === action.payload.id) {
          item.maxPercentage = action.payload.maxPercentage;
          item.maxPercentageAccessories = action.payload.maxPercentageAccessories;
          item.maxPercentageInsurance = action.payload.maxPercentageInsurance;

          item.maxPrice = parseFloat(
            (item.basePrice * (ONE_HUNDRED_PERCENT_NUMERIC_FORMAT + item.maxPercentage)).toFixed(2),
          );
        }
      });
      return state;
    },
  },
});
